module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "noise.000c717a.svg";